
export class DcsAccountNumber {
    primaryCustomerAgreementNumber: string
    primaryCustomerScheduleNumber: string
}
